import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl text-black leading-16 mb-2" }, "Welcome to Fundequate!", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-md text-gray-400 leading-16" }, "Reporting and Transactional Platform for Investors, Funds and Startups", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-48 h-screen mt-16 mb-16 bg-red-100" }, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}